
export function isNumber(num) {
    if(isNaN(num)) return false;
    if(typeof(num) === "number") return true;
    if(typeof(num) === "string") return !isNaN(Number(num));

    return false;
}

export function isInteger(num) {
    if(!isNumber(num)) return false;
    num = Number(num);
    return Math.floor(num) === num;
}

export function fillDigits(number, totalDigits) {
    let str = number + "";
    while(str.length < totalDigits) str = "0" + str;
    return str;
}

export function range(start, end, steps = 1) {
    const arr = [];
    for(let i = start; i < end; i+=steps) arr.push(i);
    return arr;
}

export function pluralize(count, singular, plural) {
    if(!plural) plural = singular + "s";
    const word = count !== 1 ? plural : singular;
    return `${count} ${word}`;
}


export function listToCollection(list) {
    const collection = {};
    for(const item of list) collection[item.id] = item;
    return collection;
} 


/**
 * Creates a format that can be used later for object format comparison.
 */
export function createObjectFormat(ref) {
    const format = { conditions: [] };

    const refType = typeof(ref);
    const pushCondition = (error, test) => format.conditions.push({ test, error });

    if(refType==="string") {
        let [type, ...conditions] = ref.trim().split(/\s+/);

        if(type.endsWith("?")) {
            type = type.slice(0, -1);
            format.maybeString = true;
        }
        if(![ "boolean", "string", "number", "integer", "char", "any" ].includes(type))
            throw new Error(`Invalid primitive type '${type}'`);

        format.type = type;

        if(type === "char")
            pushCondition("invalid-type", (c) => typeof(c)==="string" && c.length === 1);
        else if(type === "integer")
            pushCondition("invalid-type", (n) => typeof(n) === "number" && Math.floor(n)===n);
        else if(type !== "any") pushCondition("invalid-type", (obj) => typeof(obj) === type);
        
        for(let condition of conditions) {
            condition = condition.trim();

            if(condition==="optional") format.optional = true;
            else if(condition.includes("|")) {
                const choices = condition.split("|");
                pushCondition("not-in-choices", o => choices.includes(o));
            } else if(condition.includes(":")) {
                const [ min, max ] = condition.split(":").map(s => s ? Number(s) : NaN);
                
                if(type === "number" || type === "integer") {
                    if(!isNaN(min)) pushCondition("out-of-range", (n) => n >= min);
                    if(!isNaN(max)) pushCondition("out-of-range", (n) => n <= max);
                } else if(type === "string") {
                    if(!isNaN(min)) pushCondition("out-of-range", (s) => s.length >= min);
                    if(!isNaN(max)) pushCondition("out-of-range", (s) => s.length <= max);
                }
            } else if(condition === "not-empty" && type === "string") {
                pushCondition("empty-string", (s) => s.trim().length > 0);
            }
        }
    } else if(Array.isArray(ref)) {
        format.type = "array";
        pushCondition("not-an-array", (arr) => Array.isArray(arr));

        if(ref.length > 0) {
            format.childrenType = createObjectFormat(ref[0]);
        }
    } else if(refType === "object") {
        format.type = "object";
        format.children = {};

        pushCondition("not-an-object", (obj) => typeof(obj) === "object");

        for(const key in ref) {
            const f = createObjectFormat(ref[key]);
            format.children[key] = f;
        }

    }
    
    return format;
}


/**
 * Compares an object to a given format.
 * @param {Object} obj 
 * @param {Objec} format 
 * @returns {{ ok: boolean, field: string, error: string }}
 */
export function checkObjectFormat(obj, format, trail = [], replace = () => {}) {

    const error = (err, key) => {
        const field = key ? [...trail, key].join(".") : trail.join(".");
        const error = field ? `${err}:${field}` : err;

        return { ok: false, field, error };
    };

    if(format.maybeString && typeof(obj) === "string") {
        try {
            obj = JSON.parse(obj);
            replace(obj);
        } catch(e) {}
    }

    for(const condition of format.conditions) {
        
        if(!condition.test(obj)) return error(condition.error);
    }
        
    const type = format.type;
    if(type === "object") {
        for(const key in format.children) {
            const childFormat = format.children[key];
            if(key in obj) {
                const checked = checkObjectFormat(obj[key], childFormat, [...trail, key], v => obj[key] = v);
                if(!checked.ok) return checked;
            } else {
                if(!childFormat.optional) return error("missing-field", key);
            }
        }
    } else if(type === "array") {
        if("childrenType" in format) {
            for(let i = 0; i < obj.length; i++) {
                const item = obj[i];
                const lastCrumb = (trail.length > 0 ? trail[trail.length - 1] : "") + `[${i}]`;
                const checked = checkObjectFormat(item, format.childrenType, [ ...trail.slice(0, -1), lastCrumb],
                    v => obj[i] = v);
                if(!checked.ok) return checked;
            }
        }
    }

    
    return { ok: true };
}

